import React from 'react'
import * as utils from "../../utils";

import RouterLink from "./router-link";

export default function RsvpToPerformActionLink(props) {
  if (!utils.eventHasPassed()) {
    return (
        <div className="rsvp-action-notice">
          <span className="info-icon">!</span> You must&nbsp;
          <RouterLink
            to={utils.eventTabUrlPath("rsvp")}
            trackingSrc="rsvp-to-perform-action-link"
          >
            RSVP
          </RouterLink>
          &nbsp;to {props.action}
        </div>
      )
  } else {
    // Event has already passed, so no link to RSVP (since the guest can't anymore)
    // and say why.
    return (
      <div className="rsvp-action-notice">
        <span className="info-icon">!</span> You must have RSVP'd to {props.action}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/common/components/rsvp-to-perform-action-link.es6